import React from 'react';
import { useTranslation } from 'react-i18next';
import { GraphQLFormattedError } from 'graphql';
import { Values, FieldItem } from '@lib/interfaces/form';
import Form, { FormRef } from '@lib/components/ReactHookForm/FormContainer';
import replaceNullsWithUndefined from '@lib/utils/replaceNullsWithUndefined';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getAreaFields } from 'routes/Sites/utils/getSiteFormFields';
import AreaEditFormActions from './AreaEditFormActions';

export interface FormProps {
  areaData?: Values;
  formRef?: React.RefObject<FormRef | undefined>;
  // Optional: callers that don't expose the documents field (e.g.
  // DocumentView AreasTab) omit these to hide it.
  getDocumentationsLoadOptions?: GetLoadOptions;
  graphQLErrors?: readonly GraphQLFormattedError[];
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: Values) => void;
  openDocumentsModal?: () => void;
}

function AreaEditForm(props: FormProps) {
  const {
    areaData,
    formRef,
    getDocumentationsLoadOptions,
    graphQLErrors,
    loading,
    onCancel,
    onSubmit,
    openDocumentsModal,
  } = props;
  const { t } = useTranslation();
  const fields: FieldItem[] = getAreaFields({
    getDocumentationsLoadOptions,
    isEditForm: true,
    openDocumentsModal,
    t,
  });

  return (
    <Form
      actionsComponent={AreaEditFormActions}
      actionsComponentProps={{ onCancel }}
      defaultValues={areaData ? replaceNullsWithUndefined(areaData) : {}}
      fields={fields}
      formId="area-edit"
      formRef={formRef}
      graphQLErrors={graphQLErrors}
      loading={loading}
      onSubmit={onSubmit}
    />
  );
}

export default AreaEditForm;
